import { render } from "./LimitsUsage.vue?vue&type=template&id=3f7bafed&scoped=true"
import script from "./LimitsUsage.vue?vue&type=script&lang=js"
export * from "./LimitsUsage.vue?vue&type=script&lang=js"

import "./LimitsUsage.vue?vue&type=style&index=0&id=3f7bafed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7bafed"]])

export default __exports__